/**
 * PDP ingredients accordion — exclusive expand (Flutter PdpIngredientsAccordionSection).
 * Wave 24B — full-list active INCI taps open explanatory sheet (Flutter composition spans).
 */
(function () {
  'use strict';

  function openDetailSheet(title, bodyNode) {
    if (!bodyNode) return;
    if (window.ErosUI && typeof window.ErosUI.openSheet === 'function') {
      var wrap = document.createElement('div');
      wrap.className = 'eros-pdp-ingredients__sheet-body';
      wrap.appendChild(bodyNode.cloneNode(true));
      wrap.querySelectorAll('[hidden]').forEach(function (el) {
        el.removeAttribute('hidden');
      });
      window.ErosUI.openSheet({ title: title || '', content: wrap });
      return;
    }
    var dialog = document.createElement('dialog');
    dialog.className = 'eros-pdp-ingredients__dialog color-scheme color-scheme--dialog';
    var inner = document.createElement('div');
    inner.className = 'eros-pdp-ingredients__dialog-inner';
    var h = document.createElement('p');
    h.className = 'h4';
    h.textContent = title || '';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'button';
    close.textContent = 'OK';
    close.addEventListener('click', function () {
      dialog.close();
    });
    inner.appendChild(h);
    inner.appendChild(bodyNode.cloneNode(true));
    inner.appendChild(close);
    dialog.appendChild(inner);
    document.body.appendChild(dialog);
    dialog.addEventListener('close', function () {
      dialog.remove();
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    if (typeof dialog.showModal === 'function') dialog.showModal();
  }

  /**
   * Auxiliary/"helper" ingredient tap-to-function (Wave 25 — glossary parity).
   * Flutter's pdp_full_ingredient_composition_text.dart makes EVERY ingredient
   * in the full INCI list tappable when it matches either an active OR a
   * glossary entry with function tags — not just actives (bindInciActives
   * above only covers actives). This mirrors the glossary half: fetch the
   * bundled ingredient_glossary.json once per PDP, normalize names the same
   * way as ingredient_name_normalizer.dart, and open a sheet listing each
   * matched function tag (bold label + description), same content as
   * showGlossaryIngredientTagSheet().
   */
  var glossaryCache = null;
  var glossaryPromise = null;

  function normalizeIngredientName(raw) {
    var s = (raw || '').trim().toLowerCase();
    s = s.replace(/​/g, '').replace(/ /g, ' ');
    s = s.replace(/\s+/g, ' ');
    return s.trim();
  }

  function loadGlossary(url) {
    if (glossaryPromise) return glossaryPromise;
    glossaryPromise = fetch(url)
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (json) {
        glossaryCache = json && typeof json === 'object' ? json : { ingredients: {}, function_tags: {} };
        return glossaryCache;
      })
      .catch(function () {
        glossaryCache = { ingredients: {}, function_tags: {} };
        return glossaryCache;
      });
    return glossaryPromise;
  }

  function buildGlossarySheetBody(displayName, entry, tags) {
    var wrap = document.createElement('div');
    var codes = (entry && entry.function_tag_codes) || [];
    var shown = 0;
    codes.forEach(function (code) {
      var tag = tags[code];
      if (!tag) return;
      shown += 1;
      var block = document.createElement('div');
      block.className = 'eros-pdp-ingredients__glossary-tag';
      var label = document.createElement('p');
      label.className = 'eros-pdp-ingredients__glossary-tag-label';
      label.textContent = tag.label_ar || code;
      var desc = document.createElement('p');
      desc.className = 'eros-pdp-ingredients__glossary-tag-desc';
      desc.textContent = tag.description_ar || '';
      block.appendChild(label);
      block.appendChild(desc);
      wrap.appendChild(block);
    });
    return shown > 0 ? wrap : null;
  }

  function bindGlossarySpans(root, glossaryUrl) {
    if (!glossaryUrl) return;
    var candidates = root.querySelectorAll(
      '.eros-pdp-ingredients__inci-text span:not(.eros-pdp-ingredients__inci-active)'
    );
    if (!candidates.length) return;

    loadGlossary(glossaryUrl).then(function (glossary) {
      var ingredients = (glossary && glossary.ingredients) || {};
      var tags = (glossary && glossary.function_tags) || {};

      candidates.forEach(function (span) {
        if (span.dataset.erosGlossaryBound === '1') return;
        var raw = (span.textContent || '').trim();
        var norm = normalizeIngredientName(raw);
        var entry = norm ? ingredients[norm] : null;
        if (!entry) return;
        var body = buildGlossarySheetBody(raw, entry, tags);
        if (!body) return;

        span.dataset.erosGlossaryBound = '1';
        span.classList.add('eros-pdp-ingredients__inci-glossary');
        span.setAttribute('role', 'button');
        span.setAttribute('tabindex', '0');

        var icon = document.createElement('span');
        icon.className = 'eros-pdp-ingredients__inci-glossary-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8z"/></svg>';
        span.appendChild(icon);

        function open() {
          openDetailSheet(raw, body);
        }
        span.addEventListener('click', function (event) {
          event.preventDefault();
          open();
        });
        span.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            open();
          }
        });
      });
    });
  }

  function findActiveTile(root, inciNorm) {
    if (!root || !inciNorm) return null;
    var tiles = root.querySelectorAll('[data-eros-pdp-active]');
    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var a = (tile.getAttribute('data-inci') || '').trim().toLowerCase();
      var b = (tile.getAttribute('data-name-en') || '').trim().toLowerCase();
      if (a && a === inciNorm) return tile;
      if (b && b === inciNorm) return tile;
    }
    return null;
  }

  function bindInciActives(root) {
    root.querySelectorAll('.eros-pdp-ingredients__inci-active').forEach(function (span) {
      if (span.dataset.erosInciBound === '1') return;
      span.dataset.erosInciBound = '1';
      if (span.tagName !== 'BUTTON') {
        span.setAttribute('role', 'button');
        span.setAttribute('tabindex', '0');
      }
      span.style.cursor = 'pointer';

      function openFromSpan() {
        var raw = (span.textContent || '').trim();
        var norm = raw.toLowerCase();
        var tile = findActiveTile(root, norm);
        if (!tile) return;
        var panel = tile.querySelector('[data-eros-pdp-active-panel]');
        var titleEl = tile.querySelector('.eros-pdp-ingredients__title');
        var title = (titleEl && titleEl.textContent) || raw;
        if (!panel) return;
        openDetailSheet(title, panel);
      }

      span.addEventListener('click', function (event) {
        event.preventDefault();
        openFromSpan();
      });
      span.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openFromSpan();
        }
      });
    });
  }

  function bindRoot(root) {
    if (!root || root.dataset.erosPdpIngredientsBound === '1') return;
    root.dataset.erosPdpIngredientsBound = '1';

    var tiles = root.querySelectorAll('[data-eros-pdp-active]');
    tiles.forEach(function (tile) {
      var btn = tile.querySelector('[data-eros-pdp-active-toggle]');
      var panel = tile.querySelector('[data-eros-pdp-active-panel]');
      var icon = tile.querySelector('[data-eros-pdp-active-icon]');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var willOpen = panel.hasAttribute('hidden');
        tiles.forEach(function (other) {
          var otherPanel = other.querySelector('[data-eros-pdp-active-panel]');
          var otherBtn = other.querySelector('[data-eros-pdp-active-toggle]');
          var otherIcon = other.querySelector('[data-eros-pdp-active-icon]');
          if (!otherPanel || !otherBtn) return;
          otherPanel.setAttribute('hidden', '');
          otherBtn.setAttribute('aria-expanded', 'false');
          if (otherIcon) otherIcon.textContent = '+';
        });
        if (willOpen) {
          panel.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '−';
        }
      });
    });

    bindInciActives(root);
    bindGlossarySpans(root, root.getAttribute('data-glossary-url'));
  }

  function init() {
    document.querySelectorAll('[data-eros-pdp-ingredients]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var roots = event.target.querySelectorAll
      ? event.target.querySelectorAll('[data-eros-pdp-ingredients]')
      : [];
    roots.forEach(function (root) {
      root.dataset.erosPdpIngredientsBound = '';
      bindRoot(root);
    });
  });
})();
